import { z } from "zod";

import { deeplinkSchema } from "../deeplinkSchema";
import { imagesSchema } from "../imagesSchema";

const answerSchema = z.object({
  id: z.number(),
  text: z.string(),
  correct: z.boolean(),
  percentage: z.number(),
});

const userAnswerSchema = z.object({
  game_id: z.number().optional(),
  user_id: z.number().optional(),
  question_id: z.number().optional(),
  answer_id: z.number().nullable(),
  seconds_elapsed: z.number(),
});

const questionSchema = z.object({
  id: z.number(),
  text: z.string(),
  category: z.string(),
  user_answer: userAnswerSchema.nullable(),
  answers: z.array(answerSchema),
  explanation: z.string().optional().nullable(),
});

const summarySchema = z.object({
  total_seconds_elapsed: z.number(),
  streak: z.number(),
  longest_streak: z.number(),
});

const recommendationSchema = z.object({
  id: z.number(),
  title: z.string(),
  description: z.string(),
  image_url: z.url(),
  deeplink: z.string(),
  color_hex: z.string().optional().nullable(),
});

export const gameStateEnum = z.enum(["UNSTARTED", "STARTED", "FINISHED"]);

export type GameState = z.infer<typeof gameStateEnum>;

export const triviaGameSchema = z.object({
  available_at: z.string(),
  ends_at: z.string(),
  id: z.number(),
  is_in_routine: z.boolean().optional(), // optional because it's not attached if the requesting API version is too low
  player_count: z.number(),
  questions: z.array(questionSchema),
  recommendations: z.array(deeplinkSchema),
  state: gameStateEnum,
  summary: summarySchema,
  images: imagesSchema,
});

export type TriviaGame = z.infer<typeof triviaGameSchema>;
export type TriviaQuestion = z.infer<typeof questionSchema>;
export type TriviaAnswer = z.infer<typeof answerSchema>;
export type TriviaUserAnswer = z.infer<typeof userAnswerSchema>;
export type TriviaRecommendation = z.infer<typeof recommendationSchema>;
